export const version = "strings/5.7.0";
//# sourceMappingURL=_version.js.map